import { Amplify } from "aws-amplify";
import { AppRegistry } from "react-native";
import environment from "setup/environment";

import App from "./App";

Amplify.configure({
  Auth: {
    region: environment.USER_POOL_REGION,
    userPoolId: environment.USER_POOL_ID,
    userPoolWebClientId: environment.USER_POOL_WEB_CLIENT_ID,
  },
});

AppRegistry.registerComponent("App", () => App);
AppRegistry.runApplication("App", {
  rootTag: document.getElementById("root"),
});
